/*@flow*/
import * as I from 'immutable';

export default function getCompanyId(): any {
  const id = I.getIn(window, ['CONFIG', 'ME', 'company_id'], null);
  return window.companyId || id;
}
